import { Component, Input, OnInit } from '@angular/core';
import { ReturnViewService } from '../../../return-view.service';
import {
  FIRM_ETC_TYPE_KEY,
  FIRM_ETC_TYPE_LABELS,
  INCOME_FORM_FIRM_ETC_KEYS,
  IncomeFormFirmEtcKey,
} from '../../../../constants/income-from-firm-etc-constant';

@Component({
    selector: 'app-income-from-firm-etc-en-v2',
    templateUrl: './income-from-firm-etc-en-v2.component.html',
    styleUrls: [
        './income-from-firm-etc-en-v2.component.css',
        '../../../shared/return-view-text-fields.css',
    ],
    standalone: false
})
export class IncomeFromFirmEtcEnV2Component implements OnInit {
  @Input() returnData: any;
  @Input() printActive: boolean = false;

  incomeFormFirmEtcData: any[] = [];

  readonly firmEtcTypeKey = FIRM_ETC_TYPE_KEY;

  constructor(private returnViewService: ReturnViewService) { }

  getValue(item: any, key: string): any {
    return item ? item[key] : null;
  }

  hasValue(item: any, key: string): boolean {
    const val = this.getValue(item, key);
    return val !== null && val !== undefined && val !== '';
  }

  getFirmEtcType(item: any): string {
    return String(this.getValue(item, this.firmEtcTypeKey) || '').trim();
  }

  getFirmEtcTypeTitle(firmEtcType: any): string {
    const v = firmEtcType === null || firmEtcType === undefined ? '' : String(firmEtcType).trim();
    return FIRM_ETC_TYPE_LABELS[v] || v;
  }

  isApplicableForType(particular: IncomeFormFirmEtcKey, firmEtcType: string): boolean {
    if (!particular.types || particular.types.length === 0) {
      return true;
    }
    return particular.types.includes(firmEtcType);
  }

  getTextParticulars(item: any): IncomeFormFirmEtcKey[] {
    const firmEtcType = this.getFirmEtcType(item);
    return INCOME_FORM_FIRM_ETC_KEYS
      .filter((k) => k.type === 'text' && k.key !== this.firmEtcTypeKey && this.isApplicableForType(k, firmEtcType))
      .slice()
      .sort((a, b) => a.order - b.order);
  }

  getAmountParticulars(item: any): IncomeFormFirmEtcKey[] {
    const firmEtcType = this.getFirmEtcType(item);
    return INCOME_FORM_FIRM_ETC_KEYS
      .filter((k) => k.type === 'amount' && this.isApplicableForType(k, firmEtcType))
      .slice()
      .sort((a, b) => a.order - b.order);
  }

  getDisplayValue(item: any, particular: IncomeFormFirmEtcKey): any {
    const val = this.getValue(item, particular.key);
    if (particular.key === 'IS_FE_CHK_TAX_PAID_TOTAL_INCM_BY_FIRM_AOP') {
      const v = String(val || '').trim().toUpperCase();
      if (v === 'T' || v === '1') {
        return 'Yes';
      }
      if (v === 'F' || v === '0') {
        return 'No';
      }
    }
    return val;
  }

  ngOnInit(): void {
    const firmEtcData = this.returnData?.incomeData?.firmEtcData;
    this.incomeFormFirmEtcData = Array.isArray(firmEtcData) ? firmEtcData : [];
  }
}
